import { languageHelper } from "../../../config/helperFunctions";
import React, { useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function ViewItem() {
  const [columns] = useState([
    {
      header: languageHelper("SN"),
      accessorKey: "SN",

    },
    {
      header: languageHelper("User"),
      accessorKey: "User",
    },
    {
      header: languageHelper("Category"),
      accessorKey: "Category",
    },
    {
      header: languageHelper("Quantity"),
      accessorKey: "Quantity",
    },
    {
      header: "	Start Date",
      accessorKey: "Start",
    },
    {
      header: "	Expiry date (MM/YY)",
      accessorKey: "Expirydate",
    },
    {
      header: languageHelper("Actions"),
      accessorKey: "total",
      cell: (row) => <Dropdown />,
    },

  ]);
  const [data] = useState([
    {
      SN: '1',
      Category: 'Sandwich',
      Quantity: '2023-10-01',
      Start: "2023 - 10 - 25",
      Expirydate: "20"
    }

  ]);


  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={languageHelper("Assign Item Category")}



      />
    </main>
  );
}

export default ViewItem;
